import React, { useContext, useEffect } from "react";
import { getProvidersUrl } from "../../actions/GetSelectProviderURL";
import { Button, HollowButton, MainContainer, Title } from "../../components";
import config from "../../config";
import { ThemeContext } from "../../contexts/ThemeContext";
import { sendEvent } from "../../hooks/analytics";
import { useQueryParams } from "../../hooks/queryParams";
import {
  Container,
  ContainerButton,
  ContainerInfoButton,
  ErrorContent,
  ErrorId,
  FlexContent,
  MessageDescription,
  TextLabel
} from "./../styles";
import { ErrorInfo, getErrorInfo } from "./ErrorTemplate";
import { SetIconByCode } from "./Icons";
import { GloboHelpButton } from "src/components/GloboHelpButton";

const chooseError = (code?: string): ErrorInfo => getErrorInfo(code);

const ErrorPage = () => {
  const { setHeaderReturn, setHeaderUser } = useContext(ThemeContext);
  setHeaderReturn(true);
  setHeaderUser(true);

  const queryParams = useQueryParams();
  const code = queryParams.get("error_code") || "";
  const errorId = queryParams.get("error_id") || "";
  const errorIdText = errorId ? `Código ${errorId}` : "";
  const globoId = localStorage.getItem("globoId") || "";
  const providerName = localStorage.getItem("providerName") || "";

  const redirectTo = (url: string) => {
    window.location.href = url;
  };

  const redirectToSignIn = () => {
    const logo = queryParams.get("logo");
    const name = queryParams.get("name");

    window.location.href = `/signin?logo=${logo}&name=${name}`;
  };

  const error = chooseError(code);
  const redirectToProviderSelection = () => {
    const action =
      error.action === "help-center-or-try-another-provider"
        ? "tentar_outra_operadora"
        : "tentar_novamente";

    sendEvent(
      "component_click",
      {
        component_name: action,
        component_type: "button",
        component_item_link_redirect: getProvidersUrl(),
        page_name_custom: error.label.replace(/\s+/g, "_").toLowerCase(),
        provider_name: providerName
      },
      {
        user_code: globoId,
        user_code_provider: "cadun"
      }
    );

    window.location.href = getProvidersUrl();
  };

  const redirectToTerms = () => {
    sendEvent(
      "component_click",
      {
        component_name: "seguir_com_associacao",
        component_type: "button",
        component_item_link_redirect: `${config.FE_BASE_URL}/terms?hasResource=false`,
        page_name_custom: error.label.replace(/\s+/g, "_").toLowerCase(),
        provider_name: providerName
      },
      {
        user_code: globoId,
        user_code_provider: "cadun"
      }
    );

    redirectTo(`${config.FE_BASE_URL}/terms?hasResource=false`);
  };

  const getAction = () => {
    switch (error.action) {
      case "try-again":
        return (
          <ContainerButton>
            <Button onClick={redirectToProviderSelection}>
              Tentar de novo
            </Button>
          </ContainerButton>
        );
      case "authentication-error":
        return (
          <ContainerButton>
            <Button onClick={redirectToSignIn}>Tentar de novo</Button>
          </ContainerButton>
        );
      case "try-again-another-provider":
        return (
          <ContainerButton>
            <Button onClick={redirectToProviderSelection}>
              Tentar outra operadora
            </Button>
          </ContainerButton>
        );
      case "association-or-try-another-provider":
        return (
          <ContainerButton>
            <Button onClick={redirectToTerms}>Seguir com associação</Button>
            <HollowButton onClick={redirectToProviderSelection}>
              Tentar outra operadora
            </HollowButton>
          </ContainerButton>
        );
      case "help-center-or-try-another-provider":
        return (
          <ContainerInfoButton>
            <ContainerButton>
              <Button onClick={redirectToProviderSelection}>
                Tentar de novo
              </Button>
              <GloboHelpButton
                pageNameCustom={error.label.replace(/\s+/g, "_").toLowerCase()}
                providerName={providerName}
                globoId={globoId}
              />
            </ContainerButton>
          </ContainerInfoButton>
        );
      default:
        return <></>;
    }
  };

  useEffect(() => {
    if (error.label) {
      sendEvent(
        "alf_page_view",
        {
          user_code_provider_hit: "cadun",
          page_name_custom: error.label.replace(/\s+/g, "_").toLowerCase(),
          provider_name: providerName
        },
        { user_code: globoId, user_code_provider: "cadun" }
      );
    }
  }, [globoId, providerName, error.label]);

  return (
    <MainContainer>
      <Container>
        <FlexContent>
          {SetIconByCode(code)}
          <ErrorContent>
            {errorId && <ErrorId>{errorIdText}</ErrorId>}
            <Title>{error.title}</Title>
          </ErrorContent>
        </FlexContent>
        <MessageDescription>
          <span>{error.description}</span>
        </MessageDescription>
      </Container>
      {getAction()}
    </MainContainer>
  );
};

export default ErrorPage;
